import axios from 'axios';
import router from './router';
import { Message } from 'element-ui'; // 导入 Element UI 中的 Message 组件
import Vue from 'vue';

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // 设置基础URL  https://test.wqxqs.com
  timeout: 5000, // 设置超时时间
});


let isNavigating = false;

// 添加请求拦截器
axiosInstance.interceptors.request.use(
  config => {
        // if(config.url.startsWith("/admin-api")){

        //   let accessToken = JSON.parse(localStorage.getItem("USER_ADMIN_INFO"));
        //   if(accessToken) {
        //     config.headers.Authorization = 'Bearer '+accessToken;
        //   } 
        // }else{
        //   let userInfo =  Vue.prototype.$getUserInfo();
        //   if(userInfo){
        //       config.headers.Authorization = 'Bearer '+userInfo.accessToken;
        //   }
        // }

        let userInfo =  Vue.prototype.$getUserInfo();
          if(userInfo){
              config.headers.Authorization = 'Bearer '+userInfo.accessToken;
          }
        
    // 在发送请求之前做些什么，例如加入 token
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axiosInstance.interceptors.response.use(
  response => {
    // 对响应数据做些什么
    return response.data;
  },
  error => {
    console.log("异常信息",error)
    let userInfo =  Vue.prototype.$getUserInfo();
    if(error.response&&error.response.status == 401){
      if (!isNavigating) {
        isNavigating = true;
        localStorage.removeItem("USER_INFO")
        localStorage.setItem('ERROR_INFO', 'value');
        let interval = localStorage.getItem('getSayInfoInterval');
        if(interval){
          clearInterval(interval); // 清除定时器
        }
        // if(!userInfo.type){
        //   location.href=process.env.VUE_APP_H5_LOGIN_URL
        //   Message.error('token已失效请重新登陆');
        //  }else if(userInfo.type == "H5_SAY") {
        //   location.href=process.env.VUE_APP_QR_LOGIN_URL
        //  }
        location.href= "https://qz.wqxqs.com/#/code"

      }
    }
    // 对响应错误做些什么
    return Promise.reject(error);
  }
);

export default axiosInstance;